<template>
    <v-dialog v-model="show" fullscreen hide-overlay transition="slide-x-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close">
                <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-toolbar-title>Editar perfil</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn dark text @click="save">
                    Guardar
                </v-btn>
            </v-toolbar>
            <v-card :loading="loading">
                <v-card-subtitle>
                    <form>
                        <v-text-field
                            v-model="user.name"
                            label="Nombre"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="user.business"
                            label="Empresa"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="user.vehicles"
                            label="Vehículos"
                            type="number"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="user.ordersPerVehicle"
                            label="Pedidos máximos por vehículo"
                            type="number"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="user.hoursPerVehicle"
                            label="Horas máximas de ruta por vehículo"
                            type="number"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="user.serviceMinutes"
                            label="Minutos de servicio"
                            type="number"
                            required
                        ></v-text-field>
                    </form>
                </v-card-subtitle>
            </v-card>
        </v-card>
    </v-dialog>
</template>

<script>
import { Auth } from '../firebase/auth';
import { DB } from '../firebase/db';

export default {
    name: 'edit-profile',

    data: () => ({
        uid: '',
        user: {
            name: '',
            business: '',
            vehicles: 0,
            ordersPerVehicle: 0,
            hoursPerVehicle: 0,
            serviceMinutes: 0
        },
        show: false,
        loading: false
    }),

    async created() {

        this.uid = (await Auth.getCurrentUser()).uid;
        let snapshot = await DB.collection('users').doc(this.uid).get()
        if(snapshot) {
            this.user = snapshot.data()
        }

    },

    mounted() {
        this.show = true
    },

    methods: {
        close() {
            this.$router.go(-1)
        },

        async save() {

            this.loading = true
            this.user.ordersPerVehicle = parseInt(this.user.ordersPerVehicle)
            this.user.hoursPerVehicle = parseInt(this.user.hoursPerVehicle)
            this.user.serviceMinutes = parseInt(this.user.serviceMinutes)
            await DB.collection('users').doc(this.uid).update(this.user)
            this.loading = false
            this.close()

        }
    }
}
</script>